import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsMenuWidget" */ './SportsMenuWidget'),
  modules: ['./SportsMenuWidget'],
  loading: () => <div />
});

export default LoadableWidget;
